import { combineReducers } from "redux";
import associationsReducer from "./associations-fetch";

const reducers = combineReducers({ associationsReducer });

export default reducers;
